import { useState, createContext, useContext } from "react";

const DEFAULT_VOLUME = 0.5;

export const useVolumeState = () => {
  const [volume, setVolume] = useState(DEFAULT_VOLUME);

  return { volume, setVolume };
};

const Context = createContext();

export const VolumeProvider = ({ children }) => {
  const value = useVolumeState();
  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export const useVolumeContext = () => {
  const context = useContext(Context);
  if (!context) {
    throw new Error("useVolumeContext must be used within a VolumeProvider");
  }
  return context;
};
